import React from 'react';
import Header from '../../components/Header/Header.jsx';
import HeaderLinks from '../../components/Header/HeaderLinks.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import Loading from '../../components/Loading/Loading.jsx';
import getFileData, { fetchPublicDataFile } from '../../APICall/Api.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import componentsStyle from '../../assets/jss/material-kit-react/views/components.jsx';
import image from '../../assets/img/bg7.jpg';

class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: window.language.setLanguage(props.match.params.lang).components,
      isLoaded: false,
      error: null,
      staff: null,
      url: getFileData,
    };
  }

  componentWillReceiveProps(newProps) {
    const lang = window.language.setLanguage(newProps.match.params.lang).components;
    this.setState({ language: lang });
    if (newProps.match.params.lang !== this.props.match.params.lang) {
      this.setState({ isLoaded: false });
      this.callAPI(newProps.match.params.lang);
    }
  }

  componentDidMount() {
    this.callAPI(this.props.match.params.lang);
  }

  callAPI = (lang) => {
    fetchPublicDataFile(`Staff${lang.capitalize()}.json`)
      .then(
        (result) => this.setState({ isLoaded: true, staff: result.staff }),
        (error)  => this.setState({ isLoaded: true, error }),
      );
  };

  getTextParagraphs = (text) => {
    const clean = `${text || ''}`.replace(/\r\n/g, '\n').trim();
    if (!clean) return [];

    const explicitParagraphs = clean
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean);

    if (explicitParagraphs.length > 1) {
      return explicitParagraphs;
    }

    const sentences = clean
      .replace(/\s+/g, ' ')
      .match(/[^.!?]+[.!?]+(?:["'’”])?/g);

    if (!sentences || sentences.length < 3) {
      return explicitParagraphs;
    }

    const paragraphs = [];
    for (let i = 0; i < sentences.length; i += 2) {
      paragraphs.push(sentences.slice(i, i + 2).join(' ').trim());
    }

    return paragraphs;
  };

  formatText = (text) => (
    <div className="bgg-about-content">
      {this.getTextParagraphs(text).map((line, i) => (
        <p className={i === 0 ? 'bgg-about-lead' : ''} key={i}>
          {line}
        </p>
      ))}
    </div>
  );

  render() {
    const { language } = this.state;
    const rest = { ...this.props };
    delete rest.classes;

    return (
      <div>
        {/* Fixed header */}
        <Header
          fixed
          color="transparent"
          changeColorOnScroll={{ height: 200, color: 'white' }}
          brand={language.title}
          rightLinks={
            <HeaderLinks
              language={language}
              match={this.props.match}
              history={this.props.history}
            />
          }
          {...rest}
        />

        {/* Hero banner */}
        <div
          className="bgg-page-hero bgg-about-hero"
          style={{
            backgroundImage: `linear-gradient(135deg,rgba(27,94,32,0.88) 0%,rgba(0,0,0,0.55) 100%), url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="bgg-container">
            <h1>{language.aboutus ? language.aboutus.title : 'About Us'}</h1>
            <p style={{ opacity: 0.88, maxWidth: 540, margin: '0 auto', lineHeight: 1.75 }}>
              Build Green Group Albania
            </p>
          </div>
        </div>

        {/* About text card */}
        <div style={{ background: '#f6f8fa', paddingBottom: 60 }}>
          <div className="bgg-about-card">
            <div className="bgg-social-row" style={{ justifyContent: 'flex-end', marginBottom: 28 }}>
              <a href="https://twitter.com/bggroup_al" target="_blank" rel="noopener noreferrer"
                 className="bgg-social-btn twitter">
                <i className="fab fa-twitter" />
              </a>
              <a href="https://www.facebook.com/Build-Green-Group-118078778536093/" target="_blank" rel="noopener noreferrer"
                 className="bgg-social-btn facebook">
                <i className="fab fa-facebook" />
              </a>
              <a href="https://www.instagram.com/buildgreenalbania/" target="_blank" rel="noopener noreferrer"
                 className="bgg-social-btn instagram">
                <i className="fab fa-instagram" />
              </a>
            </div>
            {language.aboutus && language.aboutus.text
              ? this.formatText(language.aboutus.text)
              : null}
          </div>
        </div>

        {/* Team section */}
        {this.state.isLoaded && this.state.staff && (
          <section className="bgg-team-section">
            <div className="bgg-container">
              <div className="bgg-section-header">
                <span className="bgg-section-label">Our People</span>
                <div>
                  <h2 className="bgg-section-title">{this.state.staff.title || 'Our Team'}</h2>
                </div>
                {this.state.staff.description && (
                  <p className="bgg-section-subtitle">{this.state.staff.description}</p>
                )}
              </div>
              <div className="bgg-team-grid">
                {(this.state.staff.list || []).map((member, key) => (
                  <div className="bgg-team-card" key={key}>
                    <div className="bgg-team-photo-wrap">
                      {member.photo || member.img
                        ? <img
                            src={member.photo || member.img}
                            alt={member.name}
                            className="bgg-team-photo"
                            loading="lazy"
                            decoding="async"
                          />
                        : <div className="bgg-team-photo-placeholder"><i className="fas fa-user" /></div>
                      }
                    </div>
                    <div className="bgg-team-name">{member.name}</div>
                    <div className="bgg-team-role">{member.position || member.role}</div>
                    <div className="bgg-team-social">
                      {member.linkedin && (
                        <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-linkedin" />
                        </a>
                      )}
                      {(member.social || []).map((s, i) => (
                        <a key={i} href={s.link} target="_blank" rel="noopener noreferrer">
                          <i className={`fab fa-${s.title}`} />
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
        {!this.state.isLoaded && <Loading />}

        <Footer {...language} match={this.props.match} {...this.props} />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(AboutUs);



// WEBPACK FOOTER //
// ./src/views/About Us/AboutUs.jsx